<div class="overlay-page" *ngIf="loading">
    <div class="loading-box">
        <!--<div class="loading-img"><img src="assets/images/load-logo.png"></div>-->
        <div class="spinner-border text-white " role="status"></div>
    </div>
</div>

<div class="navbar p-0 pl-3 top-navbar">
    <div class="col-md-2 brand-logo npm"><img src="assets/images/logo.jpeg"></div>
    <div class="col-md-2 brand-logo npm"><img src="assets/images/mpma.jpeg"></div>
    <div class="col-md-10 npm">
        <!-- <ul class="navbar-nav ml-auto ml-md-0 text-right pr-3 user-con">

            <li class="nav-item dropdown user-box ">
                <a class="nav-link dropdown-toggle" href="#" id="userDropdown" role="button" data-toggle="dropdown"
                    aria-haspopup="true" aria-expanded="false"> <span class="smt-avatar"> <img
                            src="assets/images/avatar-9.jpg" width="36" height="36"> </span>
                    <span class="user-name">User Name</span>
                </a>



                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdown">
                    <a class="dropdown-item" href="changepassword.html"> <span class="la la-wrench smt-icon"
                            aria-hidden="true"></span> <span>Change Password</span> </a>
                    <a class="dropdown-item" href="login.html"> <span class="la la-sign-out smt-icon"
                            aria-hidden="true"></span> <span>Logout</span> </a>
                </div>

            </li>

        </ul> -->
    </div>
</div>
<!--Topbar End-->

<!--Navigation-->
<!-- <nav class="navbar navbar-expand-sm navbar-light bg-faded p-0">

    <div class="collapse navbar-collapse pl-2  pr-2" id="nav-content">
        <ul class="navbar-nav">

            <li class="nav-item">
                <a class="nav-link" href="dashboard.html"><i class="la la-dashboard"></i> Dashboard</a>
            </li>

            <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" data-toggle="dropdown" id="Preview" href="#" role="button"
                    aria-haspopup="true" aria-expanded="false">
                    <i class="la la-money"></i> Manage Order</a>
                <div class="dropdown-menu" aria-labelledby="Preview">
                    <a class="dropdown-item" href="purchase-order.html"> <i class="la la-money"></i> Purchase
                        Order</a>
                </div>
            </li>






        </ul>
    </div> 

</nav>-->
<!--Navigation End-->


<section>
    <div class="row bs-wizard col-md-12">

        <div class="col-sm-4 bs-wizard-step complete">
            <div class="progress">
                <div class="progress-bar"></div>
            </div>
            <a href="#" class="bs-wizard-dot"></a>
            <div class="bs-wizard-info text-center">Purchase order</div>
        </div>


        <div class="col-sm-4 bs-wizard-step complete">
            <!-- complete -->
            <div class="progress">
                <div class="progress-bar"></div>
            </div>
            <a href="#" class="bs-wizard-dot"></a>
            <div class="bs-wizard-info text-center">Confirm Order</div>
        </div>

        <div class="col-sm-4 bs-wizard-step active">
            <!-- active -->
            <div class="progress">
                <div class="progress-bar"></div>
            </div>
            <a href="#" class="bs-wizard-dot"></a>
            <div class="bs-wizard-info text-center">Deliver Address</div>
        </div>
    </div>
</section>

<div class="content-sec">
    <div class="col-md-12 p-0">
        <div class="card content-box">





            <div class="card-header">
                <h3><i class="la la-money"></i>DELIVERY ADDRESS </h3>
            </div>


            <div class="col-md-12" *ngIf="deliveryForm">
                <form [formGroup]="deliveryForm">

                    <div class="row mt-4">

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">Name</label>
                            <i class="la la-user"></i>
                            <input type="text" class="form-control transparent-tb" placeholder="Enter Name"
                                formControlName="name">
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('name').valid && deliveryForm.get('name').touched">Required
                                Field</small>
                        </div>

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">Street/Unit no</label>
                            <i class="la la-map"></i>
                            <input type="text" class="form-control transparent-tb" placeholder="Street / Unit no"
                                formControlName="address">
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('address').valid && deliveryForm.get('address').touched">Required
                                Field</small>
                        </div>

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">State</label>
                            <i class="la la-map-pin"></i>
                            <input type="text" class="form-control transparent-tb" placeholder="Enter State"
                                formControlName="state">
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('state').valid && deliveryForm.get('state').touched">Required
                                Field</small>
                        </div>

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">Postcode / Town</label>
                            <i class="la la-map-pin"></i>
                            <input type="text" class="form-control transparent-tb" placeholder="Postcode / Town"
                                formControlName="pincode">
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('pincode').valid && deliveryForm.get('pincode').touched">Required
                                Field</small>
                        </div>

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">Phone Number</label>
                            <i class="la la-map-pin"></i>
                            <input type="text" class="form-control transparent-tb" placeholder="Enter Phone Number"
                                formControlName="phone">
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('phone').valid && deliveryForm.get('phone').touched">Required
                                Field</small>
                        </div>

                        <div class="col-lg-6 col-md-12 col-sm-12 form-group icon-form">
                            <label class="label">Email</label>
                            <i class="la la-map-pin"></i>
                            <input type="email" class="form-control transparent-tb" placeholder="Email" email
                                formControlName="email">
                                <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('email').valid  && deliveryForm.get('email').touched && deliveryForm.get('email').errors.Required">Required Field</small>
                            <small class="form-text text-danger"
                                *ngIf="!deliveryForm.get('email').valid  && deliveryForm.get('email').touched && deliveryForm.get('email').errors.email">Not a valid email address</small>
                        </div>



                    </div>

                    <div class="text-right mt-3 mb-4">
                        <button type="button" class="btn btn-primary" [disabled]="deliveryForm.invalid"
                            (click)="submitOrder()">Submit</button>
                        <button type="button" class="btn btn-success" (click)="cancelOrder()">Cancel</button>
                    </div>
                </form>
            </div>

        </div>
    </div>
</div>

<ng-template #successModal let-modal>
    <div class="modal-content modal-confirm">
        <div class="modal-header">
            <div class="icon-box">
                <i class="ft-check"></i>
            </div>
            <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-hidden="true">×</button>
        </div>
        <div class="modal-body text-center">
            <h4>Success</h4>
            <p class="text-success">Order submitted successfully !!</p>
            <button class="btn btn-success" (click)="modal.dismiss('Cross click')">Close</button>
        </div>
    </div>
</ng-template>

<ng-template #errorModal let-modal>
    <div class="modal-content modal-reject ">
        <div class="modal-header">
            <div class="icon-box">
                <i class="ft-alert-triangle"></i>
            </div>
            <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-hidden="true">×</button>
        </div>
        <div class="modal-body text-center">
            <h4>Failure</h4>
            <p class="text-danger">Error while submitting order. Please try again.</p>
            <button class="btn btn-success" (click)="modal.dismiss('Cross click')">Close</button>
        </div>
    </div>
</ng-template>


<div class="col-md-12">
    <div class="text-center mt-3">
        Powered by : <a href="https://zastainfotek.com/" target="_blank">ZastaInfotek</a>
    </div>
</div>